import api from 'api';
import {unpackId} from 'common/diplomatIdUtil';
import {usePostApi} from 'common/hooks/usePostApi';
import {pageTypes} from 'features/layout/CommonPage/redux';
import {layoutActions} from 'features/layout/redux';
import {useToasts} from 'features/notifications/useToasts';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {action} from 'redux/helpers';
import {sftpUserSelectors} from 'redux/sftp-user';
import {IVFSGroup} from 'types/diplomat/sftp/VFSGroup';
import {IDiplomatObject} from 'types/DiplomatObject';

export const useRenameSftpGroup = (id: string, onClose?: () => void) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();
   const {addToast} = useToasts();
   const onSuccess = (data: IVFSGroup) => {
      dispatch(layoutActions.loadTreeNav());
      dispatch(action(pageTypes.GET_DATA.SUCCESS, data));

      addToast(t('Successfully renamed sftp group {{name}}', {name: data.name}), {
         appearance: 'success',
      });
      onClose?.();
   };
   const {request} = usePostApi(`${api.vfsgroups}/${id}/rename`, {onSuccess, onFailure: onClose});

   const sftpGroups = useSelector(sftpUserSelectors.getSftpGroups);
   const validateName = React.useCallback(
      (value: string) => {
         const isNameExists = sftpGroups.some((obj: IDiplomatObject) => obj.name === value);
         if (isNameExists) {
            return t(`Diplomat already contains a SFTP Group named {{name}}`, {
               name: value,
            });
         }
      },
      [sftpGroups, t]
   );

   const rename = React.useCallback(
      (values: {groupName: string}) => {
         request(null, {searchParams: values});
      },
      [request]
   );

   return {
      rename,
      validateName,
   };
};
